import { AuthService } from '@auth';
import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { map, filter, tap } from 'rxjs/operators';

import { LogService } from '../helpers/log.service';

import { UserService } from './../services/api/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements OnDestroy {
  protected readonly unsubscribe$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private logService: LogService
  ) {}

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.isUserAuthenticated(state);
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.isUserAuthenticated(state);
  }

  private isUserAuthenticated(state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authService.firebaseUser$.pipe(
      filter((fbUser) => fbUser !== undefined), // Wacht tot de gebruiker geladen is
      tap((fbUser) => this.logService.log('Firebase User:', fbUser)),
      map((fbUser) => {
        if (!fbUser) {
          // Gebruiker is niet ingelogd, stuur door naar de loginpagina
          const urlTree = this.router.parseUrl('/login');
          urlTree.queryParams = { returnUrl: state.url };
          return urlTree;
        } else {
          return true;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }
}
